import { Heading, Text, UnorderedList, LinkText } from '@propertypal/web-ui/src/typography';
import Head from 'next/head';
import React from 'react';
import PageWrapper from '../../../web-ui/src/layout/PageWrapper';
import generateMetaTags from '../components/layout/MetaTags';

const metaData = {
  title: 'PSR Licence Number',
  description:
    'A PSR Licence Number is issued by the Property Services Regulatory Authority (PSRA) to all businesses that provide property services in Ireland.',
  url: `/psr-licence-number`,
};

const PsrLicenceNumber = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <PageWrapper containerStyle={{ margin: '60px auto' }}>
        <Heading>PSR LICENCE NUMBER</Heading>

        <Text mt={30} style={{ fontStyle: 'italic' }}>
          Last updated: 31st October 2018
        </Text>

        <Text mt={15}>
          A PSR Licence Number is issued by the Property Services Regulatory Authority (PSRA) to all businesses that
          provide property services in Ireland.
        </Text>

        <Text mt={15}>
          All Auctioneers, Estate Agents, Letting Agents and Property Management Agents must be licensed and regulated
          by the PSRA.
        </Text>

        <Text mt={15}>
          This applies to companies, partnerships, independent contractors and sole traders, together with their
          principal officers and employees who provide property services in Ireland. This means property located in the
          Republic of Ireland and transactions in Ireland which relate to property located abroad.
        </Text>

        <Text mt={15}>The regulatory environment provides for:</Text>

        <UnorderedList>
          <li>A comprehensive licensing system covering all property services providers (PSPs)</li>
          <li>The investigation and adjudication of complaints made against PSPs</li>
          <li>The audit/inspection of PSPs operations</li>
          <li>The establishment of minimum qualification standards</li>
        </UnorderedList>

        <Text mt={15}>No PSR Licence therefore means no protection for the consumer.</Text>

        <Heading mt={30}>HOW TO GET A PSR NUMBER</Heading>

        <Text mt={15}>
          Any business or person who provides property services in Ireland can apply for or renew a PSR licence with the
          Property Services Regulation Authority.
        </Text>

        <Text mt={15}>
          You can find more information on{' '}
          <LinkText href="https://www.psr.ie/" target="_blank" rel="nofollow">
            PSR.ie
          </LinkText>
          .
        </Text>
      </PageWrapper>
    </>
  );
};

export default PsrLicenceNumber;
